module.exports = {
	images: {
		all: /\.(png|jpe?g|gif|svg|webp)(\?.*)?$/,
		jpeg: /\.(jpe?g)(\?.*)?$/,
	}
};
